// Raw API calls for portfolio data. Components never call axios
// directly — they go through the hooks in src/hooks/, which wrap these.
import { http } from "../http";

export const getDashboard = () => http.get(`/dashboard`).then((r) => r.data);

export const getSnapshots = (startDate) =>
  http
    .get(`/snapshots`, { params: startDate ? { start_date: startDate } : {} })
    .then((r) => r.data);

/** Per-day totals per asset group (investments, cash, …), for the Assets page charts. */
export const getSnapshotGroups = (startDate) =>
  http
    .get(`/snapshots/groups`, { params: startDate ? { start_date: startDate } : {} })
    .then((r) => r.data);

export const createAsset = (payload) => http.post(`/assets`, payload).then((r) => r.data);
export const updateAsset = (id, payload) => http.put(`/assets/${id}`, payload).then((r) => r.data);
export const removeAsset = (id) => http.delete(`/assets/${id}`).then((r) => r.data);

// Entries of a ledger US-stocks portfolio; writes return { transaction, asset }.
export const getTransactions = (assetId) =>
  http.get(`/assets/${assetId}/transactions`).then((r) => r.data);
export const createTransaction = (assetId, payload) =>
  http.post(`/assets/${assetId}/transactions`, payload).then((r) => r.data);
export const updateTransaction = (assetId, id, payload) =>
  http.put(`/assets/${assetId}/transactions/${id}`, payload).then((r) => r.data);
export const removeTransaction = (assetId, id) =>
  http.delete(`/assets/${assetId}/transactions/${id}`).then((r) => r.data);

// Proof files (PDF / images) attached to an entry.
const proofsURL = (assetId, txId) => `/assets/${assetId}/transactions/${txId}/attachments`;
export const getAttachments = (assetId, txId) => http.get(proofsURL(assetId, txId)).then((r) => r.data);
export const uploadAttachment = (assetId, txId, file, kind) => {
  const form = new FormData();
  form.append("file", file);
  if (kind) form.append("kind", kind);
  return http.post(proofsURL(assetId, txId), form).then((r) => r.data);
};
export const getAttachmentLink = (assetId, txId, id) =>
  http.get(`${proofsURL(assetId, txId)}/${id}/url`).then((r) => r.data.url);
export const removeAttachment = (assetId, txId, id) =>
  http.delete(`${proofsURL(assetId, txId)}/${id}`).then((r) => r.data);

export const createLiability = (payload) => http.post(`/liabilities`, payload).then((r) => r.data);
export const updateLiability = (id, payload) => http.put(`/liabilities/${id}`, payload).then((r) => r.data);
export const removeLiability = (id) => http.delete(`/liabilities/${id}`).then((r) => r.data);
